module.exports = __webpack_public_path__ + "img/text-security-disc.6b5dea63.svg";